import * as actions from './../../../actions';
import * as actionTypes from './../../../constants/actionTypes';
import { getApiConfig } from './../../../utilities';
import { createNewFilterGroupItem } from './../../../components/Filters/FiltersReducer';
import _ from 'lodash';

const { get, post } = getApiConfig('Dashboard_Stones');

const NameRegex = new RegExp(/([^a-zA-Z\'\s\-0-9])/gim);
const _isValidName = (text) => {
  return _.trim(text.replace(NameRegex, "")).length > 0;
}

export function showNewStonePopup(show) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.NEW_STONE_POPUP_SHOW,
      payload: {
        show
      }
    });
  }
}

export function showEditStonePopup(show, stone) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.EDIT_STONE_POPUP_SHOW,
      payload: {
        show,
        stone
      }
    });
  }
}

function separateFilters(state, stonesV2) {
  let materialFilters = [],
    colorFilters = [];

  let materialFilterValues = _.first(stonesV2.filterGroupLookupTable.filter(f => f.group == "Stone Material")).values;
  let colorFilterValues = _.first(stonesV2.filterGroupLookupTable.filter(f => f.group == "Stone Color")).values;

  for(var i = 0; i < state.selectedFilters.length; i++) {
    let f = state.selectedFilters[i];
    if(materialFilterValues.indexOf(f) >= 0) {
      materialFilters.push(f);
    } else if(colorFilterValues.indexOf(f) >= 0) {
      colorFilters.push(f);
    }
  }
  
  return {
    materialFilters,
    colorFilters
  }
}

export function saveNewStone(state) {
  return (dispatch, getState) => {
    const { auth, search, stonesV2, asCustomer } = getState();
    const { materialFilters, colorFilters } = separateFilters(state, stonesV2);
    let errs = [];
    if(!state.name || _.trim(state.name).length == 0) {
      errs.push("Please enter the stone's Name.");
    } else if(!_isValidName(state.name)) {
      errs.push("Stone Name must contain descriptive text.");
    } else if(_.trim(state.name).length > 45) {
      errs.push("Stone Name cannot be more than 45 characters.");
    }
    if(!state.description || _.trim(state.description).length == 0) {
      errs.push("Please enter the stone's Description.");
    } else if(!_isValidName(state.description)) {
      errs.push("Stone description must contain descriptive text.");
    } else if(_.trim(state.description).length > 2048) {
      errs.push("Stone Description cannot be more than 2048 characters.");
    }
    state.description = $('<div>' + state.description + '</div>').text();  //sanitize description input to remove html
    if(!state.image) {
      errs.push("Please upload the stone's Image.");
    }
    if(materialFilters.length == 0) {
      errs.push("Please select at least 1 Material Filter");
    }
    if(colorFilters.length == 0) {
      errs.push("Please select at least 1 Color Filter");
    }
    if(errs.length == 0) {
      let data = new FormData();
      let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
      data.append("fabricatorId", fabricatorId);
      data.append("name", _.trim(state.name));
      data.append("description", _.trim(state.description));
      data.append("image", state.image);
      data.append("materialFilters", materialFilters);
      data.append("colorFilters", colorFilters);
      dispatch(actions.loadingDialog_show(true, "Saving...", "Saving your new Stone..."))
        .then(() => post(data, 'AddNewStone'))
        .then(() => dispatch(actions.fetchStones()))
        .then(() => dispatch(showNewStonePopup(false)))
        .then(() => dispatch(actions.setSearchTerm(search.term + " "))) //triggering a change to the search term forces the stone page to update
        .then(() => dispatch(actions.setSearchTerm(search.term))) //revert to previous term after triggering change
        .then(() => dispatch(actions.loadingDialog_show(false)));
    } else {
      dispatch(actions.messageBox_Show(true, 'error', 'Missing Stone Data', errs.join('<br />')));
    }
  }
}

export function updateStone(state) {
  return (dispatch, getState) => {
    const { auth, search, stonesV2, asCustomer } = getState();
    const { materialFilters, colorFilters } = separateFilters(state, stonesV2);
    let errs = [];
    if(!state.name || _.trim(state.name).length == 0) {
      errs.push("Please enter the stone's Name.");
    } else if(!_isValidName(state.name)) {
      errs.push("Stone Name must contain descriptive text.");
    } else if(_.trim(state.name).length > 45) {
      errs.push("Stone Name cannot be more than 45 characters.");
    }
    if(!state.description || _.trim(state.description).length == 0) {
      errs.push("Please enter the stone's Description.");
    } else if(!_isValidName(state.description)) {
      errs.push("Stone description must contain descriptive text.");
    } else if(_.trim().length > 2048) {
      errs.push("Stone Description cannot be more than 2048 characters.");
    }
    state.description = $('<div>' + state.description + '</div>').text(); //sanitize description input to remove html
    if(materialFilters.length == 0) {
      errs.push("Please select at least 1 Material Filter");
    }
    if(colorFilters.length == 0) {
      errs.push("Please select at least 1 Color Filter");
    }
    if(errs.length == 0) {
      let data = new FormData();
      let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
      data.append("id", state.id);
      data.append("fabricatorId", fabricatorId);
      data.append("name", _.trim(state.name));
      data.append("description", _.trim(state.description));
      data.append("image", state.image);
      data.append("materialFilters", materialFilters);
      data.append("colorFilters", colorFilters);
      dispatch(actions.loadingDialog_show(true, "Saving...", "Saving your Stone..."))
        .then(() => post(data, 'EditStone'))
        .then(() => dispatch(actions.fetchStones()))
        .then(() => dispatch(showNewStonePopup(false)))
        .then(() => dispatch(actions.setSearchTerm(search.term + " "))) //triggering a change to the search term forces the stone page to update
        .then(() => dispatch(actions.setSearchTerm(search.term))) //revert to previous term after triggering change
        .then(() => dispatch(actions.loadingDialog_show(false)));
    } else {
      dispatch(actions.messageBox_Show(true, 'error', 'Missing Stone Data', errs.join('<br />')));
    }
  }
}

export function createColorFilter(color, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { stonesV2 } = getState();
      let errs = [];
      if(!color || _.trim(color).length == 0) {
        errs.push('Please enter a valid Color Filter Name.');
      } else if(!_isValidName(color)) {
        errs.push('Color Filter Name must contain descriptive text.');
      } else if(_.trim(color).length > 50) {
        errs.push('Color Filter Name cannot be more than 50 characters.');
      }

      if(!value || _.trim(value).length == 0) {
        errs.push('Please select a color.');
      }
    
      if(errs.length > 0) {
        dispatch(actions.messageBox_Show(true, 'error', 'Invalid data entered', errs.join('<br />')));
        reject();
        return;
      }
      const filterGroup = _.first(stonesV2.filterGroups.filter(fg => fg.name == 'Stone Color'));
      var newFilter = createNewFilterGroupItem(filterGroup.id, "Color");
      newFilter.value = _.trim(value);
      newFilter.displayText = _.trim(color);
      newFilter.description = _.trim(color);
      dispatch(uploadNewFilter(newFilter, 'Stone Color')).then(resolve).catch(reject);
    });
  }
}

export function createMaterialFilter(name, isQuartz) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { stonesV2 } = getState();
      let errs = [];
      if(!name || _.trim(name).length == 0) {
        errs.push('Please enter a valid Material Filter Name.');
      } else if (!_isValidName(name)) {
        errs.push('Material Filter Name must contain descriptive text.');
      } else if (_.trim(name).length > 50) {
        errs.push('Material Filter Name cannot be more than 50 characters.');
      }

      if(errs.length > 0) {
        dispatch(actions.messageBox_Show(true, 'error', 'Invalid data entered', errs.join('<br />')));
        reject();
        return;
      }
      const filterGroup = _.first(stonesV2.filterGroups.filter(fg => fg.name == 'Stone Material'));
      const quartzGroup = _.first(filterGroup.values.filter(g => _.trim(g.value).toLowerCase() == 'quartz'));
      var newFilter = createNewFilterGroupItem(filterGroup.id, "Text");
      newFilter.value = _.trim(name);
      newFilter.displayText = _.trim(name);
      newFilter.description = _.trim(name);
      if(isQuartz) {
        newFilter.parentId = quartzGroup.id;
      }
      dispatch(uploadNewFilter(newFilter, 'Stone Material')).then(resolve).catch(reject);
    });
  }
}

function uploadNewFilter(filter, type) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const {post} = getApiConfig('Filters');
      var formData = new FormData();
      formData.append('json', JSON.stringify(filter));
      dispatch(actions.loadingDialog_show(true, 'Saving...', 'Saving ' + type + ' Filter item...'));
      post(formData, 'SaveFilterGroupValue')
      .then(response => {
        dispatch(actions.loadingDialog_show(false));
        dispatch({
          type: actionTypes.ADD_STONE_FILTER,
          payload: {filter: response, type}
        });
        resolve(response);
      }).catch(reject);
    });
  };
}

export function showImageUploadNotice(preview) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
        payload: {
          visible: true,
          title: 'Verify Image Ownership',
          message: '<img src="' + preview + '" align="left" style="margin: -20px 20px 0 0; max-width: 45%; max-height: 200px;" /><span style="text-align:justify;display: block;font-size: 0.95em; float: right; width: 310px;">I own this image and agree to take all responsibility with copyright infringement associated with this image. I herby authorize Quote Countertops and any other affiliate companies to use this image for the use in their software.</span>',
          type: 'system',
          buttons: [{
            text: 'Yes',
            subtext: 'I own this image and agree',
            onClick: () => {
              resolve();
              dispatch(actions.messageBox_Show(false));
            }
          }, {
            text: 'No',
            subtext: 'I am NOT authorized to use this image',
            onClick: () => {
              reject();
              dispatch(actions.messageBox_Show(false));
            } 
          }]
        }
      });
      dispatch(actions.loadingDialog_show(false));
    });
  }
}
